module.exports = __webpack_public_path__ + "static/img/IMG_20241208_184013.1b21b089.jpg";